import { z } from "zod";

const translationPath = "page.register.roles.errors.";

const ticketDefaultDocCategorySchema = z
  .object({
    id: z.string(),
    name: z.string(),
    code: z.union([z.string(), z.number()]).optional(),
  })
  .nullish()
  .refine((value) => !!value, {
    message: translationPath + "ticket_default_doc_category",
  });

export const profileTicketDefaultDocCategorySchema = z.object({
  ticketDefaultDocCategory: ticketDefaultDocCategorySchema,
});

export type TProfileTicketDefaultDocCategoryForm = z.infer<
  typeof profileTicketDefaultDocCategorySchema
>;
